import * as React from 'react';

type Props = {
  children?: React.ReactNode;
  classes?: string;
};

const List = ({ children, classes = '' }: Props) => {
  return <ul className={`flex flex-col gap-2 ${classes}`}>{children}</ul>;
};
export default List;
